import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { WatcherService } from 'src/app/services/watcher.service';

@Component({
  selector: 'app-shop-amazon-us',
  templateUrl: './shop-amazon-us.component.html',
  styleUrls: ['./shop-amazon-us.component.css'],
})
export class ShopAmazonUsComponent implements OnInit, OnDestroy {
  lang: string = 'en';
  constructor(private watcherService: WatcherService, private router: Router) {}

  createAmazonSchema() {
    // Schema for Amazon
    if (!document.getElementById('shopAmazonUsSchema')) {
      const amazonSchema = {
        "@context": "https://schema.org",
        "@type": "WebPage",
        "headline": "How to Shop Amazon and Ship Internationally",
        "description": "Discover how to shop on Amazon and arrange for international shipping with ease. Explore tips and guidelines for navigating global delivery options and ensuring your purchases arrive safely and promptly.",
        "url": `https://www.shippn.com/${this.lang}/stores/how-to-shop-amazon-and-ship-internationally`,
        "author": [{
          "@type": "Person",
          "name": "Shippn Team",
          "url": `https://www.shippn.com/${this.lang}/about`
        }]
      };
      const scriptEl = document.createElement('script');
      scriptEl.type = 'application/ld+json';
      scriptEl.innerHTML = JSON.stringify(amazonSchema);
      scriptEl.id = 'shopAmazonUsSchema';
      document.head.appendChild(scriptEl);
    }
  
    // Breadcrumb Schema
    if (!document.getElementById('shopAmazonUsBreadcrumbSchema')) {
      const breadcrumbSchema = {
        "@context": "https://schema.org",
        "@type": "BreadcrumbList",
        "itemListElement": [
          {
            "@type": "ListItem",
            "position": 1,
            "item": {
              "@id": `https://www.shippn.com/${this.lang}/home`,
              "name": "Home"
            }
          },
          {
            "@type": "ListItem",
            "position": 2,
            "item": {
              "@id": `https://www.shippn.com/${this.lang}/stores`,
              "name": "Best Global Stores for International Shipping"
            }
          },
          {
            "@type": "ListItem",
            "position": 3,
            "item": {
              "@id": `https://www.shippn.com/${this.lang}/stores/how-to-shop-amazon-and-ship-internationally`,
              "name": "How To Shop Amazon and Ship Internationally"
            }
          }
        ]
      };
      const scriptEl = document.createElement('script');
      scriptEl.type = 'application/ld+json';
      scriptEl.innerHTML = JSON.stringify(breadcrumbSchema);
      scriptEl.id = 'shopAmazonUsBreadcrumbSchema';
      document.head.appendChild(scriptEl);
    }
  
    // Article Schema
    if (!document.getElementById('shopAmazonUsArticleSchema')) {
      const articleSchema = {
        "@context": "https://schema.org",
        "@type": "Article",
        "headline": "How to Shop Amazon and Ship Internationally",
        "image": [
          "https://www.shippn.com/assets/img/stores/amazon/Amazon_logo.webp",
          "https://www.shippn.com/assets/img/stores/amazon/step-1.webp",
          "https://www.shippn.com/assets/img/stores/amazon/step-2.webp",
          "https://www.shippn.com/assets/img/stores/amazon/step-3.webp"
        ],
        "datePublished": "2024-08-29T14:31:13.976Z",
        "dateModified": "2024-08-29T14:31:13.976Z",
        "author": [{
          "@type": "Person",
          "name": "Shippn Team",
          "url": `https://www.shippn.com/${this.lang}/about`
        }],
        "url": `https://www.shippn.com/${this.lang}/stores/how-to-shop-amazon-and-ship-internationally`
      };
      const scriptEl = document.createElement('script');
      scriptEl.type = 'application/ld+json';
      scriptEl.innerHTML = JSON.stringify(articleSchema);
      scriptEl.id = 'shopAmazonUsArticleSchema';
      document.head.appendChild(scriptEl);
    }
  }

  ngOnInit(): void {
    this.watcherService.getLang().subscribe((lang) => {
      this.lang = lang;
      this.createAmazonSchema();
    });
  }

  goToSignIn() {
    this.router.navigate(['/', this.lang, 'signin']);
  }

  ngOnDestroy(): void {
    const schemas = ['shopAmazonUsSchema', 'shopAmazonUsBreadcrumbSchema', 'shopAmazonUsArticleSchema'];
    
    schemas.forEach(schemaId => {
      const schemaElement = document.getElementById(schemaId);
      if (schemaElement) {
        document.head.removeChild(schemaElement);
      }
    });
  }
}
